import { render } from "./GeolocationsTable.vue?vue&type=template&id=61614e68&scoped=true"
import script from "./GeolocationsTable.vue?vue&type=script&lang=js"
export * from "./GeolocationsTable.vue?vue&type=script&lang=js"

import "./GeolocationsTable.vue?vue&type=style&index=0&id=61614e68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61614e68"]])

export default __exports__